export type SycurioPCIResponseType = {
  lastFour: string;
  expYear: string;
  expMonth: string;
  cardType: string;
  avsPostalCode: string;
  token: string;
  cardHolderName: string;
  ppErrorCode: string;
  ppErrorMessage: string;
};

export const getSycurioPCIResponse = (
  sycurioEventData: string,
): SycurioPCIResponseType => {
  const { data } = JSON.parse(sycurioEventData);
  const {
    token,
    cardHolderName,
    lastFour,
    expYear,
    expMonth,
    cardType,
    avsPostalCode,
    ppErrorCode,
    ppErrorMessage,
  } = data;
  return {
    token,
    cardHolderName,
    lastFour,
    expYear,
    expMonth,
    cardType,
    avsPostalCode,
    ppErrorCode,
    ppErrorMessage,
  };
};
